import { MenuUpOutlineIcon } from './MenuUpOutlineIcon';

/**
 * author: Austin Andrews
 * id 33B1FB6B-D4F4-4B76-820C-4A2B075DB1B3
 * name menu-up-outline
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-up-outline.svg
 * tags
 * - Arrow 
 */
export const CaretUpOutlineIcon = MenuUpOutlineIcon;
export default CaretUpOutlineIcon